import { Container } from '@mui/material';
import React from 'react';
import { ScrollRestoration, useLoaderData } from 'react-router-dom';
import AppBar from '../app-bar/AppBar';
import Breadcrumbs from '../breadcrumbs/Breadcrumbs';
import MdViewer from '../markdown/MdViewer';

const TermsOfUse = () => {
  const terms = useLoaderData() as string;

  return (
    <>
      <AppBar title="Terms of Use" />
      <Breadcrumbs
        items={[{ label: 'Home', to: '/' }, { label: 'Profile', to: '/profile' }, { label: 'Terms of Use' }]}
        sx={{ display: { xs: 'none', sm: 'flex' } }}
      />
      <ScrollRestoration />
      <Container sx={{ my: 4 }}>
        <MdViewer text={terms}></MdViewer>
      </Container>
    </>
  );
};

export default TermsOfUse;
